import React, {useEffect, useRef} from 'react';

export const Fireworks = () => {
    const canvasRef = useRef(null);

    const start = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        canvas.setAttribute("style", "position: fixed; top: 0; left: 0; pointer-events: none; z-index: 9999")
        const count = 500;
        const confettiColors = ['#ff0', '#ff6347', '#32cd32', '#1e90ff', '#ff1493'];

        function createConfetti() {
            const particles = [];
            for (let i = 0; i < count; i++) {
                const shapeType = Math.random() < 0.5 ? 'circle' : (Math.random() < 0.5 ? 'square' : 'diamond');
                particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height - canvas.height,
                    size: Math.random() * 6 + 4,
                    color: confettiColors[Math.floor(Math.random() * confettiColors.length)],
                    velocityX: (Math.random() - 0.5) * 6,
                    velocityY: Math.random() * 10 + 3,
                    rotation: Math.random() * Math.PI * 2,
                    rotationSpeed: (Math.random() - 0.5) * 0.1,
                    shape: shapeType
                });
            }
            return particles;
        }

        const particles = createConfetti();

        function drawShape(p, shape) {
            ctx.save();
            ctx.translate(p.x, p.y);
            ctx.rotate(p.rotation);
            ctx.fillStyle = p.color;

            if (shape === 'circle') {
                ctx.beginPath();
                ctx.arc(0, 0, p.size, 0, Math.PI * 2);
                ctx.fill();
                ctx.closePath();
            } else if (shape === 'square') {
                ctx.beginPath();
                ctx.rect(-p.size / 2, -p.size / 2, p.size, p.size);
                ctx.fill();
                ctx.closePath();
            } else if (shape === 'diamond') {
                ctx.beginPath();
                ctx.moveTo(0, -p.size);
                ctx.lineTo(p.size, 0);
                ctx.lineTo(0, p.size);
                ctx.lineTo(-p.size, 0);
                ctx.closePath();
                ctx.fill();
            }
            ctx.restore();
        }

        function animateConfetti() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            for (let i = 0; i < particles.length; i++) {
                const p = particles[i];
                p.x += p.velocityX;
                p.y += p.velocityY;
                p.rotation += p.rotationSpeed;
                if (p.y > canvas.height) {
                    p.y = -p.size;
                }
                drawShape(p, p.shape);
            }

            requestAnimationFrame(animateConfetti);
        }

        animateConfetti();
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        start();
        canvas.style.opacity = 1;
        setTimeout(() => {
            const i = setInterval(() => canvas.style.opacity = canvas.style.opacity - 0.05, 100);
            setTimeout(() => clearInterval(i), 2000)
        }, 1000)
    }, [])

    return (
        <canvas ref={canvasRef}/>
    )
}
